import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';
import { array } from 'prop-types';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});


var token= ''
var sacco= ''
var username=''



class JournalEntryAccountChangeForm extends React.Component {

  state = {
    datarequested:true,
    companyaccounts: [],
    debited_account:'',
    previous_account:'',
    new_account:'',

  }

  callback(key) {
    console.log(key);
  }

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
        sacco= ''
        username=''
    }
   
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
            companyaccounts:res.data
        })

        this.setState({datarequested:false})
    })


  }


  //submit the deposit now
  handleFormSubmit=(event) =>{

    if(this.state.new_account===""){
      message.info("New Account missing")
     }else if(this.state.previous_account===""){
      message.info("Previous Account missing")
     }
     else{

      this.setState({datarequested:true})
  
      let form_data = new FormData();

      form_data.append('sacco', sacco);
      form_data.append('username', username);
      form_data.append('new_account', this.state.new_account);
      form_data.append('previous_account', this.state.previous_account);

      axios.post(serverconfig.backendserverurl+'/customqueries/changesaccount_onjournals', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.message)

        if (res.data.message==="Success"){
          this.setState({datasubmittedsuccessfully:true})
        }

      })
      .catch(error => console.log(error))
     }

  }


  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>
            <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card>
                    <Result
                    status="success"
                    title="Successfully Made change "
                    extra={[
                      <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>
                    ]}
                    />

                    </Card>
                 </Col>
            </Row>
          </div>)
      }else{
        return(
          <div>
            <div>
  
              <Row >
                  <Col xs="12" sm="6" lg="12">
                    <Card>

                     <FormItem label="Previous Account" >
                      <Input name="previous_account"  
                      placeholder="Previous Account" 
                      value={this.state.previous_account}
                      onChange={(val)=>{this.setState({previous_account:val.target.value})}} 
                      />
                     </FormItem>                  


                    <FormItem label=" Select New Account">
                        <Select 
                        placeholder="New Account" 
                        style={{  }} 
                        value={this.state.new_account}
                        onChange={(val)=>{this.setState({new_account:val})}} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                                             
                        >
                          {this.state.companyaccounts.map(
                            (accnt)=>(
                              <Option value={accnt.account_name}>{accnt.account_name} | {accnt.account_code}</Option>
                            ))}
                        </Select>
                    </FormItem>


                    <FormItem>
                      <Button
                      onClick={()=>{
                        this.handleFormSubmit()

                      }}

                      type="primary" 
                      htmlType="button">Update All Journals</Button>
                    </FormItem>
  
                  </Card>
                  
                </Col>
  
            </Row>
            </div>
  
       </div>              
                      
        )
      }

    }
   
  }
}

export default JournalEntryAccountChangeForm; 
